import React, { useRef, useState } from "react";
import { Ripple } from "primereact/ripple";
import styles from "./Pricing.module.css";

const PricingPage = () => {
  const [isHidden, setIsHidden] = useState(true);
  const menuRef = useRef(null);

  const toggleMenuItemClick = (e) => {
    e.preventDefault();
    setIsHidden((prevState) => !prevState);
  };

  const getImagePath = (imageName) => {
    return process.env.PUBLIC_URL + "/images/" + imageName;
  };

  return (
    <div className={`${styles.pageContainer} relative`}>
      <div
        className={`${styles.container} relative overflow-hidden flex flex-column`}
      >
        {/* Navigation */}
        <div className={`${styles.navigation} px-4 md:px-8 py-4 relative`}>
          <div className="flex align-items-center justify-content-between w-full">
            {/* Logo on far left */}
            <div className="flex align-items-center select-none">
              <a href="/app">
                <img
                  src={getImagePath("headerlogo2.png")}
                  alt="Interesting"
                  className={styles.headerLogo}
                />
              </a>
            </div>

            {/* Mobile menu toggle - only visible on mobile */}
            <button
              onClick={toggleMenuItemClick}
              className="cursor-pointer block lg:hidden border-none bg-transparent p-2"
              type="button"
              aria-label="Toggle menu"
            >
              <i className={`${styles.mobileMenuIcon} pi pi-bars text-2xl`}></i>
            </button>

            {/* Desktop Navigation */}
            <div
              className={`${styles.desktopNav} hidden lg:flex align-items-center justify-content-between`}
            >
              {/* Center menu items */}
              <div className="flex align-items-center justify-content-center flex-grow-1">
                <ul className="list-none p-0 m-0 flex align-items-center select-none">
                  <li className="mx-3">
                    <a href="/app/offering" className={`${styles.menuItem} `}>
                      <span>Offering</span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="mx-3">
                    <a
                      href="/app/pricing"
                      className={`${styles.menuItem} ${styles.activeMenuItem}`}
                    >
                      <span>Pricing</span>
                      <Ripple />
                    </a>
                  </li>
                  {/* <li className="mx-3">
                    <a href="#why-us" className={`${styles.menuItem} `}>
                      <span>Why us</span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="mx-3">
                    <a href="#ting" className={`${styles.menuItem} `}>
                      <span>Ting</span>
                      <Ripple />
                    </a>
                  </li> */}
                  <li className="mx-3">
                    <a href="/app/contact" className={`${styles.menuItem} `}>
                      <span>Contact us</span>
                      <Ripple />
                    </a>
                  </li>
                </ul>
              </div>

              {/* CTA button on far right */}
              <div className="flex align-items-center">
                <a
                  href="https://app.interestng.com/app/login"
                  className={styles.heroCta1}
                >
                  Login
                  <Ripple />
                </a>
              </div>
            </div>

            {/* Mobile menu - only shows on mobile when toggled */}
            {!isHidden && (
              <div
                className={`${styles.mobileMenu} block lg:hidden absolute top-full left-0 w-full shadow-2`}
              >
                <ul className="list-none p-0 m-0 flex flex-column">
                  <li>
                    <a
                      href="/app/offering"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Offering</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="/app/pricing"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Pricing</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#why-us"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Why us</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#ting"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Ting</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#contact"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Contact us</span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="p-3">
                    <a
                      href="https://app.interestng.com/app/login"
                      className={styles.ctaButton2}
                    >
                      Login
                      <Ripple />
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* All Main Sections Container */}
        <div className={styles.allSectionsContainer}>
          {/* Left Side Plans & Price Image */}
          <img
            src={getImagePath("plans&price.png")}
            alt="Plans and Price"
            className={styles.leftPlansImage}
            style={{
              position: "absolute",
              top: "-50px",
              left: "0px",
              zIndex: 90,
              width: "300px",
              height: "auto",
            }}
          />
          {/* Hero Section */}
          <div className={`${styles.heroSection} px-4 md:px-8 py-8`}>
            <div className="text-center mb-8">
              <h1 className={`${styles.heroTitle} mb-4`}>
                Plans that{" "}
                <span className={styles.blueText}>
                  grow with your
                  <br />
                  earnings
                </span>
              </h1>
              <p className={`${styles.heroSubtitle} mx-auto`}>
                Start where you are. Upgrade as you scale.
                <br />
                No lock-ins.
              </p>
            </div>

            {/* Pricing Cards */}
            <div className={`${styles.pricingCardsContainer}`}>
              <div className="grid justify-content-center w-full">
                <div className="col-12 md:col-4 p-3">
                  <div
                    className={`${styles.pricingCard} ${styles.quickStartCard}`}
                  >
                    <h3 className={styles.planTitle}>Quick Start</h3>
                    <p className={styles.planDescription}>
                      Earn from your connects
                    </p>
                    <p className={styles.planSubtext}>
                      More connects more earnings
                    </p>

                    <div className={styles.priceContainer}>
                      <span className={styles.rupeeSymbol}>₹</span>
                      <span className={styles.priceAmount}>0</span>
                    </div>

                    <div className={styles.referralInfo}>
                      <p className={styles.referralItem}>
                        <span className={styles.checkMark}>✓</span>
                        <span>
                          Earn Referral Payout from <br />
                          0.25% to 2.25%
                        </span>
                      </p>

                      <p className={styles.referralItem}>
                        <span className={styles.checkMark}>✓</span>
                        <span>
                          Access to Pay as you use verification features
                        </span>
                      </p>
                    </div>

                    <button
                      className={`${styles.planButton} ${styles.quickStartButton}`}
                    >
                      Start with Quick Start
                      <Ripple />
                    </button>

                    <a
                      href="/app/quick-start"
                      className={styles.featuresContainer}
                    >
                      <div className={styles.featuresSection}>
                        <p className={styles.featuresTitle}>Free Features:</p>
                        <ul className={styles.featuresList}>
                          <li>
                            <i className="pi pi-check"></i>Compare & share
                            multiple bank offers
                          </li>
                          <li>
                            <i className="pi pi-check"></i>Track loan status &
                            approvals easily
                          </li>
                          <li>
                            <i className="pi pi-check"></i>Referral payouts
                            visibility on disbursals
                          </li>
                          <li>
                            <i className="pi pi-check"></i>Onboard quickly to
                            bank
                          </li>
                          <li>
                            <i className="pi pi-check"></i>Pay as you use for
                            third party Verification APIs
                          </li>
                        </ul>
                      </div>

                      <div className={styles.dropdownSection}>
                        <span className={styles.dropdownToggle}>
                          <span>Who is it for?</span>
                          <i className="pi pi-chevron-down"></i>
                        </span>
                        <span className={styles.dropdownToggle}>
                          <span>How it works?</span>
                          <i className="pi pi-chevron-down"></i>
                        </span>
                        <span className={styles.dropdownToggle}>
                          <span>When you should use it?</span>
                          <i className="pi pi-chevron-down"></i>
                        </span>
                      </div>
                    </a>
                  </div>
                </div>

                <div className="col-12 md:col-4 p-3">
                  <div
                    className={`${styles.pricingCard} ${styles.standardCard}`}
                  >
                    <div className={styles.popularBadge}>Most Interesting</div>
                    <h3 className={styles.planTitle}>Standard</h3>
                    <p className={styles.planDescription}>Get Hands-On</p>
                    <p className={styles.planSubtext}>
                      More connects more earnings
                    </p>

                    <div className={styles.priceContainer}>
                      <span className={styles.rupeeSymbol}>₹</span>
                      <span className={styles.priceAmount}>999</span>
                      <span className={styles.perMonth}>/per month</span>
                    </div>

                    <div className={styles.referralInfo}>
                      <p className={styles.referralItem}>
                        <span className={styles.checkMark}>✓</span>
                        <span>
                          Earn Referral Payout from <br />
                          0.25% to 2.25%
                        </span>
                      </p>

                      <p className={styles.referralItem}>
                        <span className={styles.checkMark}>✓</span>
                        <span>
                          You get the entire payout for the loan you process
                        </span>
                      </p>
                    </div>

                    <button
                      className={`${styles.planButton} ${styles.standardButton}`}
                    >
                      Start with Standard
                      <Ripple />
                    </button>

                    <div className={styles.featuresContainer}>
                      <div className={styles.featuresSection}>
                        <p className={styles.featuresTitle}>
                          Free Features, plus:
                        </p>
                        <ul className={styles.featuresList}>
                          <li>
                            <i className="pi pi-check"></i> Distribute loans
                            beyond your city
                          </li>
                          <li>
                            <i className="pi pi-check"></i> Access expert help &
                            alternate approval options
                          </li>
                          <li>
                            <i className="pi pi-check"></i> Full payout +
                            storage & verification history see more
                          </li>
                        </ul>
                      </div>

                      <div className={styles.dropdownSection}>
                        <button className={styles.dropdownToggle}>
                          <span>Who is it for?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                        <button className={styles.dropdownToggle}>
                          <span>How it works?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                        <button className={styles.dropdownToggle}>
                          <span>When you should use it?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 md:col-4 p-3">
                  <div
                    className={`${styles.pricingCard} ${styles.premiumCard}`}
                  >
                    <h3 className={styles.planTitle}>Premium</h3>
                    <p className={styles.planDescription}>You are in charge</p>
                    <p className={styles.planSubtext}>
                      More connects more earnings
                    </p>

                    <div className={styles.priceContainer}>
                      <span className={styles.rupeeSymbol}>₹</span>
                      <span className={styles.priceAmount}>9999</span>
                      <span className={styles.perMonth}>/per month</span>
                    </div>

                    <div className={styles.referralInfo}>
                      <p className={styles.referralItem}>
                        <span className={styles.checkMark}>✓</span>
                        <span>
                          Earn Referral Payout from <br />
                          0.25% to 2.25%
                        </span>
                      </p>

                      <p className={styles.referralItem}>
                        <span className={styles.checkMark}>✓</span>
                        <span>
                          Get 100% credits every month for your API usage
                        </span>
                      </p>

                      <p className={styles.referralItem}>
                        <span className={styles.checkMark}>✓</span>
                        <span>
                          Get your own website domain and backend engine
                        </span>
                      </p>
                    </div>

                    <button
                      className={`${styles.planButton} ${styles.premiumButton}`}
                    >
                      Start with Premium
                      <Ripple />
                    </button>

                    <div className={styles.featuresContainer}>
                      <div className={styles.featuresSection}>
                        <p className={styles.featuresTitle}>
                          Standard Features, plus:
                        </p>
                        <ul className={styles.featuresList}>
                          <li>
                            <i className="pi pi-check"></i>Launch your own loan
                            website & agent network
                          </li>
                          <li>
                            <i className="pi pi-check"></i>Use social media to
                            onboard more borrowers
                          </li>
                          <li>
                            <i className="pi pi-check"></i>Higher storage &
                            complete verification access
                          </li>
                        </ul>
                      </div>

                      <div className={styles.dropdownSection}>
                        <button className={styles.dropdownToggle}>
                          <span>Who is it for?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                        <button className={styles.dropdownToggle}>
                          <span>How it works?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                        <button className={styles.dropdownToggle}>
                          <span>When you should use it?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Enterprise Section */}
          <div className={`${styles.enterpriseSection} px-4 md:px-8 py-8`}>
            <div className={styles.enterpriseContainer}>
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div className={styles.enterpriseLeftHalf}>
                    <h2 className={styles.enterpriseTitle}>Enterprise</h2>
                    <p className={styles.enterpriseSubtitle}>
                      Scale with Marketplace
                    </p>
                    <p className={styles.enterpriseDescription}>
                      More connects more <br />
                      earnings
                    </p>

                    <button className={`${styles.customPlanButton}`}>
                      Contact us for Custom price
                      <Ripple />
                    </button>

                    <ul className={styles.enterpriseFeatures}>
                      <li>
                        <span className={styles.checkMark}>✓</span> Get more
                        amount of credits as per custom pricing
                      </li>
                      <li>
                        <span className={styles.checkMark}>✓</span> Get more
                        storage as per your need
                      </li>
                      <li>
                        <span className={styles.checkMark}>✓</span> Get multiple
                        domain names for self or your agents
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className={styles.enterpriseRightHalf}>
                    <div className={styles.enterpriseFeaturesCard}>
                      <h3>Features</h3>
                      <ol className={styles.enterpriseFeaturesList}>
                        <li>
                          All features of quick start, standard and premium{" "}
                          <br />
                          included
                        </li>
                        <li>To become a national player digitally</li>
                        <li>Provide a dedicated website to each agent</li>
                        <li>Make builder, corporate and Platform tie-ups</li>
                        <li>
                          Access to all verification history and upto 5 gb{" "}
                          <br />
                          storage and database
                        </li>
                      </ol>

                      <div className={styles.dropdownSection}>
                        <button className={styles.dropdownToggle}>
                          <span>Who is it for?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                        <button className={styles.dropdownToggle}>
                          <span>How it works?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                        <button className={styles.dropdownToggle}>
                          <span>When you should use it?</span>
                          <i className="pi pi-chevron-down"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Features Comparison Section */}
          <div className={`${styles.comparisonSection} px-4 md:px-8 py-8`}>
            <h2 className={`${styles.comparisonTitle} text-center mb-6`}>
              Here's what you get in{" "}
              <span className={styles.blueText}>all plans</span>
            </h2>

            <div
              className={`${styles.featuresGrid} grid justify-content-center`}
            >
              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("get-money-svgrepo-com 1.png")}
                      alt="Loan products & schemes"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>
                    Loan products &<br />
                    schemes
                  </h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> Personal Loan
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Home Loan
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Business Loan
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Loan against Property
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("work-svgrepo-com-1.svg")}
                      alt="Banks & partners"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Banks & partners</h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> 12 Private banks
                    </li>
                    <li>
                      <i className="pi pi-check"></i> 4 Public Sector Banks
                    </li>
                    <li>
                      <i className="pi pi-check"></i> 40 NBFC
                    </li>
                    <li>
                      <i className="pi pi-check"></i> 5 Fintechs
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Banking Surrogates
                    </li>
                  </ul>
                  <p className={styles.andMore}>and more...</p>
                </div>
              </div>

              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("users-svgrepo-com (1) 1.png")}
                      alt="Borrowers we support"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Borrowers we support</h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> Salaried
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Self employed
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Family
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Partnership Firms
                    </li>
                    <li>
                      <i className="pi pi-check"></i> High Networth Individuals
                    </li>
                  </ul>
                  <p className={styles.andMore}>and more..</p>
                </div>
              </div>

              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("path1 1.png")}
                      alt="Smart verifications"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Smart verifications</h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> Income
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Identity
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Employment
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Business
                    </li>
                  </ul>
                  <p className={styles.andMore}>and more..</p>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        {/* End of All Main Sections Container */}
        {/* Final CTA Section */}
        <div className={`${styles.finalCtaSection} relative`}>
          <div className={styles.ctaWaveBackground}></div>
          <img
            src={getImagePath("plansFoooter.png")}
            alt="Plans Footer"
            className={styles.plansFooterImage}
            style={{
              position: "absolute",
              top: "50%",
              right: "-100px",
              transform: "translateY(-50%)",
              zIndex: 0,
              width: "600px",
              height: "auto",
            }}
          />
          <div
            className={`${styles.ctaContent} px-4 md:px-8 py-8`}
            style={{ position: "relative", zIndex: 10 }}
          >
            <div className={`grid align-items-center ${styles.ctaGrid}`}>
              <div className={`col-12 md:col-8 ${styles.ctaTitleColumn}`}>
                <h2 className={`${styles.ctaTitle} mb-4 md:mb-0`}>
                  Let's Stop Losing Deals
                  <br className="hidden md:block" />
                  Together
                </h2>
              </div>
              <div className={`col-12 md:col-4 ${styles.ctaButtonColumn}`}>
                <a
                  href="https://app.interestng.com/app/login"
                  className={styles.ctaButton}
                >
                  Login
                  <Ripple />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className={styles.footer}>
          <div className="px-4 md:px-8 py-8">
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className="mb-6">
                  <h3 className={styles.footerBrand}>
                    Interestng™ — Life is Dull
                    <br />
                    When You Lose Deals
                  </h3>
                  <div className={styles.footerLogoContainer}>
                    <img
                      src={getImagePath("footerLogo.svg")}
                      alt="Interesting Logo"
                      className={styles.footerLogoImage}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className="grid">
                  <div className="col-4">
                    <ul className="list-none p-0 m-0">
                      <li className="mb-3">
                        <a href="/app" className={styles.footerLink}>
                          Home
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/offering" className={styles.footerLink}>
                          Offering
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/pricing" className={styles.footerLink}>
                          Pricing
                        </a>
                      </li>
                      {/* <li className="mb-3">
                        <a href="#why-us" className={styles.footerLink}>
                          Why Us
                        </a>
                      </li> */}

                      <li className="mb-3">
                        <a href="#service" className={styles.footerLink}>
                          Service
                        </a>
                      </li>

                      <li className="mb-3">
                        <a href="#faq" className={styles.footerLink}>
                          FAQ
                        </a>
                      </li>

                      {/* <li className="mb-3">
                        <a href="#ting" className={styles.footerLink}>
                          Ting
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  <div className="col-4">
                    <ul className="list-none p-0 m-0">
                      {/* <li className="mb-3">
                        <a href="#faq" className={styles.footerLink}>
                          FAQ
                        </a>
                      </li> */}
                      <li className="mb-3">
                        <a href="/app/about" className={styles.footerLink}>
                          About Us
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/contact" className={styles.footerLink}>
                          Contact us
                        </a>
                      </li>

                      <li className="mb-3">
                        <a
                          href="/app/terms-and-conditions"
                          className={styles.footerLink}
                        >
                          Terms & Conditions
                        </a>
                      </li>
                      <li className="mb-3">
                        <a
                          href="/app/privacy-policy"
                          className={styles.footerLink}
                        >
                          Privacy Policy
                        </a>
                      </li>
                      <li className="mb-3">
                        <a
                          href="/app/refund-policy"
                          className={styles.footerLink}
                        >
                          Refund-Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PricingPage;
